import { render } from "./AfsluttedeFejl.vue?vue&type=template&id=f9c5410e&scoped=true"
import script from "./AfsluttedeFejl.vue?vue&type=script&lang=js"
export * from "./AfsluttedeFejl.vue?vue&type=script&lang=js"

import "./AfsluttedeFejl.vue?vue&type=style&index=0&id=f9c5410e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c5410e"]])

export default __exports__